import { makeStyles } from "@material-ui/core"

const useInputStyles = makeStyles(() => ({
  root: {
    minWidth: "120px",
  },
}))

export default useInputStyles
